import React, { useEffect } from 'react';
import MediaComponent from '../activity/MediaComponent';
import { activityInProgress } from '../../Store/api/activities';
import { useDispatch } from 'react-redux';

const OptionStudent = ({ question, answers, questionIndex, setAnswer, setSelectedOptionIndex, hasCorrectAnswers, isRead, completedActivity, activity, handleActivityProgress, setUpdateAnswers, setActivityAnswers, setMaximizeImage, setImageVideoUrl }) => {
  const currentAnswer = answers[questionIndex] || {};
  const answerIndex = currentAnswer.answerIndex;
  const dispatch = useDispatch();
  useEffect(() => {
    setUpdateAnswers(answers);
  }, [answers]);

  // const handleActivityProgress = () => {
  //
  //   const activityAnswerId = activity?.activityAnswers?.[0]?._id;

  //   if (!answers || !activityAnswerId) {
  //     console.error("Missing required data: answers or activityAnswer ID.");
  //     return;
  //   }

  //   dispatch(
  //     activityInProgress({
  //       body: {
  //         answers: answers,
  //         activityAnswer: activityAnswerId,
  //       },
  //       onSuccess: (res) => {
  //
  //       },
  //       onError: (err) => {
  //         console.error("API call error:", err);
  //       },
  //     })
  //   );
  // };

  return (
    <div className='mcqs-parent mr-tp-bt'>
      {question.options.map((option, index) => (
        <div
          className={`mcqs-child cursor ${['image', 'video'].includes(option.type) && 'pdb-0'} ${answerIndex === index ? 'parent-boarder selected' : ''} `}
          key={index}
          onClick={() => {
            if (hasCorrectAnswers) return;

            setAnswer(questionIndex, 'answerIndex', index);

            setSelectedOptionIndex(index);
            // handleActivityProgress();
          }}
        >
          <div className={`first_child ${!hasCorrectAnswers && answerIndex === index ? 'selected' : ''}`} style={{ paddingBottom: '0px' }}>
            <div className='option_index'>{String.fromCharCode(65 + index)}</div>
            <div className='child-b'>{option.text}</div>
          </div>
          {['image', 'video', 'audio'].includes(option.type) && <MediaComponent media={option} mode={'student'} setMaximizeImage={setMaximizeImage} setImageVideoUrl={setImageVideoUrl} />}
        </div>
      ))}
    </div>
  );
};

export default OptionStudent;
